module.exports = __webpack_public_path__ + "img/nathalie_de_loeaper_pratique_shiatsu.86e9317c.webp";